import React from 'react';
import './index.css';
import backgroundImg from './images/background1.png'; //https://raventale.itch.io/parallax-background

export default class Background extends React.Component {
  constructor(props) {
    super(props);
    this.state = {xPos:0};
  }

  slideBackground () {
    let start;
    let last;

    let step = (timestamp) =>  {
      if (start === undefined) {
        start = timestamp;
        last = timestamp;
      }
      //const elapsed = (timestamp - start) / 1000;
      const frameTime = timestamp - last
      // `Math.min()` is used here to make sure that the element stops at exactly 200px.
      //element.style.transform = 'translateX(' + Math.min(0.1 * elapsed, 200) + 'px)';
      //this.setState((props,state)=>{xPos:this.state.xPos += elapsed/1000 })

      //console.log('elapsed ' + elapsed)
      //console.log('ts ' + timestamp)
      //console.log('last ' + last)
      if (this.state.xPos < -800) {
        this.setState({xPos:0})
      }
      this.setState((state, props) => ({
        xPos: this.state.xPos - (Math.floor(frameTime / 8))
      }));
      
      last = timestamp;
      //this.setState({xPos:elapsed})
      
      if (this.props.playing === true && this.props.moving) { 
        window.requestAnimationFrame(step);
      }
      
     
    }
          window.requestAnimationFrame(step); 

  }

  componentDidMount(){
    //this.slideBackground();
    if (this.props.playing && this.props.moving) {
      let background = document.getElementById('backgroundImg')
      background.className = "bgScroll";      
    }

  }

  componentWillUnmount() {
    //clearInterval(this.state.updateScoreInt)
  }

  componentDidUpdate(prevProps){
    if(!this.props.playing) {
      let background = document.getElementById('backgroundImg')
      //background.classList.remove('bgScroll');
      background.style.animationPlayState = 'paused';
    }
    if (this.props.playing && this.props.moving) {
      let background = document.getElementById('backgroundImg')
      background.className = "bgScroll";      
    }    
  }


  render() {
    return <img id="backgroundImg" src={backgroundImg} style={{left : this.state.xPos}} alt="background"/>;    
  }

}